<div class="additional-details-form">
    <div class="title-container">
        <div class="title"> If you'd like, you can provide more details about why you chose this rating. </div>
        <hive-button emphasis="tertiary" [icon]="faXmark" (click)="closeAdditionalDetails()" />
    </div>

    <hive-text-area
        [(ngModel)]="additionalDetailsText"
        size="large"
        placeholder="Provide additional feedback"
        [maxlength]="MAX_TEXT_LENGTH"
    />

    <hive-button
        class="submit-btn"
        emphasis="tertiary"
        label="Submit"
        [disabled]="isSubmitDisabled()"
        (click)="clickSubmit()"
    />
</div>
